import { Navigate, Route, Routes } from 'react-router-dom'
import DeadLettersPage from './pages/DeadLettersPage'
import QueuesPage from './pages/QueuesPage'

const DeadLetterRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DeadLettersPage />} />
      <Route path="/queues" element={<QueuesPage />} />
      <Route path="/queues/:storageAccountName" element={<QueuesPage />} />
      <Route path="/queues/:storageAccountName/:queueName" element={<QueuesPage />} />
      <Route path="*" element={<Navigate to="/dead-letter" replace />} />
    </Routes>
  )
}

export default DeadLetterRoutes
